import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=4bda5d36"
import script from "./MyDetails.vue?vue&type=script&lang=js"
export * from "./MyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports